<template>
  <section class="d-flex flex-column align-center">
    <div class="d-flex flex-row justify-start" style="max-width: 1300px; width: 100%">
      <header-section title="Контактные данные"></header-section>
    </div>

    <div class="d-flex flex-row justify-center">
      <wrapper-preview-category style="max-width: 660px">
        <ContainerPersonContact
          :contact="contact"
          :can-be-deleted="false"
          :saving-data="savingContact"
          :is-single="true"
          :blocked="isAdminGroup || isDisabledEnter"
          :config="config"
          :ignore-personal-phone-number="true"
          :loading-contacts="loadingContacts"
          @change-contact="changeContact($event)"
        >
          <template #header>
            {{ firstContactTitle }}
          </template>
        </ContainerPersonContact>
      </wrapper-preview-category>
      <wrapper-preview-category class="ml-3" style="max-width: 660px">
        <ContainerPersonContact
          :contact="contactOne"
          :can-be-deleted="false"
          :saving-data="savingContact"
          :is-single="true"
          :blocked="isAdminGroup || isDisabledEnter"
          :config="config"
          :ignore-personal-phone-number="true"
          :loading-contacts="loadingContacts"
          @change-contact="changeContact($event, 'contactOne')"
        >
          <template #header>
            Контакты ответственного за работу в информационной системе
          </template>
        </ContainerPersonContact>
      </wrapper-preview-category>
    </div>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import HeaderSection from "@/components/headers/HeaderSection";
import ContainerPersonContact from "@/components/contacts/ContainerPersonContact";
import contacts from "@/helpers/contacts";
import {mapGetters, mapActions} from "vuex";
import ContactsController from "@/controllers/ContactsController";



export default {
  name: "Contacts",
  components: { ContainerPersonContact, HeaderSection, WrapperPreviewCategory },
  data() {
    return {
      config: contacts,
      contact:
        {
          email: '',
          fio: "",
          position: "",
          workPhoneNumber: null,
          workPhoneExtension: null,
          personalPhoneNumber: null,
          personalPhoneExtension: null,
          typeContact: 'MAIN'
        },
      contactOne:
        {
          email: '',
          fio: "",
          position: "",
          workPhoneNumber: null,
          workPhoneExtension: null,
          personalPhoneNumber: null,
          personalPhoneExtension: null,
          typeContact: 'OTV'
        },
      loadingContacts: false,
      savingContact: false,
    }
  },
  computed: {
    ...mapGetters('checkFilled', {
      get_check_filled_status: 'get_check_filled_status',
      currentStage: 'currentStage'
    }),
    ...mapGetters('keycloak', {
      isAdmin: 'isAdmin',
      isAdminGroup: 'isAdminGroup',
      isRegion: 'isRegion',
      getAuthData: 'getAuthData',
      getFakeUser: "getFakeUser",
      isDisabledEnter: "isDisabledEnter"
    }),
    firstContactTitle() {
      return (this.isRegion && !this.getFakeUser) || this.getFakeUser?.role === 'REGION_ROLE' ? 'Руководитель/ заместитель руководителя высшего исполнительного органа субъекта Российской Федерации'
        : (this.currentStage < 4) ? 'Контактная информация представителя центра ответственности, ответственного за формирование предложений о корректировке проекта контрольных цифр приёма.'
              : 'Контактная информация ответственного лица за согласование предложений по установлению контрольных цифр приема';
    }
  },
  created() {
    this.getContactsData()
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    async getContactsData() {
      this.loadingContacts = true;

      try {
        let type;
        let ID;
        if (this.getFakeUser) {
          if (this.getFakeUser.role === "FOUNDER_ROLE") {
            type = 'founder'
          } else if (this.getFakeUser.role === "REGION_ROLE") {
            type = 'region'
          }
          ID = this.getFakeUser.id
        } else {
          if (this.isRegion) {
            type = 'region';
            ID = this.getAuthData.regionID
          } else {
            type = 'founder';
            ID = this.getAuthData.founderID
          }
        }

        const res = await ContactsController.getContactController(type, ID);
        if (res && res.length > 0) {
          const contact = res.find(el => el.typeContact === 'MAIN');
          const contactOne = res.find(el => el.typeContact === 'OTV');
          for (const key of Object.keys(this.contact)) {
            if (contact)
              this.contact[key] = contact[key];
            if (contactOne)
              this.contactOne[key] = contactOne[key];
          }
          if (contact)
            this.contact.id = contact.id;
          if (contactOne)
            this.contactOne.id = contactOne.id;
        }
        this.loadingContacts = false;
      } catch (e) {
        this.loadingContacts = false;
        if (e.status !== 400)
          await this.addNotification({
            notificationStatus: 'error',
            notificationMessage: 'Ошибка получения данных ответственных исполнителей',
            timeout: 5000
          })
      }
    },
    async changeContact(obj, nameContact = 'contact') {
      this.savingContact = true;
      try {
        const res = await ContactsController.setContact(obj);
        for (const key of Object.keys(this[nameContact]))
          this[nameContact][key] = res[key];
        this[nameContact].id = res.id;
      } catch (e) {
        this.savingContact = false;
        console.error('e change contact', e);
      }
      this.savingContact = false;
    }
  },
}
</script>

<style scoped>

</style>